<template>
  <div style="height: 20vh; margin: auto">
    <el-form ref="form" :model="form" style="margin-top: 20px; " label-width="80px">
      <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
        <el-col :lg="8" :md="10" :sm="10" :xl="8" :xs="10"
                style="line-height: 28px;text-align: right;margin-right: 10px;">告警级别：
        </el-col>
        <el-col :xl="13" :lg="13" :md="13" :sm="13" :xs="13">
          <el-input class="inline-input" placeholder="请输入告警等级" size="mini" style="width: 80%" type="number"
                    v-model="form.level"></el-input>
        </el-col>
      </el-col>

      <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
        <el-col :lg="8" :md="10" :sm="10" :xl="8" :xs="10"
                style="line-height: 28px;text-align: right;margin-right: 10px;">告警名称：
        </el-col>
        <el-col :lg="13" :md="13" :sm="13" :xl="13" :xs="13">
          <el-input class="inline-input" placeholder="请输入告警名称" size="mini" style="width: 80%"
                    v-model="form.levelName"></el-input>
        </el-col>
      </el-col>

      <el-col :span="24" style="height: 8px;" class="hidden-sm-and-up"></el-col>
      <el-col :span="24" style="height: 13px;" class="hidden-md-and-down"></el-col>

      <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
        <el-col :lg="10" :md="10" :sm="10" :xl="8" :xs="10"
                style="line-height: 28px;text-align: right;margin-right: 10px;">告警颜色：
        </el-col>
        <el-col :lg="13" :md="13" :sm="13" :xl="13" :xs="13">
          <el-color-picker
            :predefine="predefineColors"
            show-alpha
            size="small"
            v-model="form.levelColor">
          </el-color-picker>
        </el-col>
      </el-col>

    </el-form>
  </div>
</template>

<script>
export default {
  name: "add",
  props: ["form"],
  data() {
    return {
      sendingMethodList: [{
        value: '1',
        label: '电话'
      },
        {
          value: '2',
          label: '邮箱'
        },
        {
          value: '3',
          label: '短信'
        }],
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ]
    }
  },
  methods: {},
  watch: {
    form(newVal) {
      this.form = newVal;
    }
  }
}
</script>

<style scoped>

</style>
